import style from './styles/Buttons.scss';

export const ContinueButton = ({ enabled = true, disabled = false, enabledMessage = 'Continue', disabledMessage = 'Please fill in the form', onClick, className, spinner = false, ...props }) => (
	<button
		type="button"
		className={`btn ${style['continue-button']}` + (enabled ? '' : ` ${style.invalid}`) + (className ? ` ${className}` : '')}
		disabled={disabled}
		onClick={onClick}
		{...props}
	>
		{spinner && <i className="fa fa-2x fa-spinner fa-spin align-middle mr-2" />}
		<span>{enabled ? enabledMessage : disabledMessage}</span>
	</button>
);

export const BackButton = ({ onClick, className }) => (
	<button type="button" className={`btn ${style['back-button'] + (className ? ` ${className}` : '')}`} onClick={onClick}>
		<span>Back</span>
	</button>
);

export const FinishButton = ({ onClick, className, children, disabled = false }) => (
	<button
		type="button"
		className={`btn ${style['finish-button']}` + (className ? ` ${className}` : '')}
		onClick={onClick}
		disabled={disabled}
	>
		{children}<span className={style.arrow} />
	</button>
);


// WEBPACK FOOTER //
// ./components/form/Buttons.js